import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-CA-Client": "web" },
});

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]}: ${x.msg}`).join(". ");
  return d || fallback;
};

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const OTP_KEY = "ca_otp";
export const REF_KEY = "ca_ref";

export const COUNTRIES = [
  ["IN", "+91", "India"], ["AU", "+61", "Australia"], ["GB", "+44", "United Kingdom"], ["PK", "+92", "Pakistan"],
  ["LK", "+94", "Sri Lanka"], ["BD", "+880", "Bangladesh"], ["NP", "+977", "Nepal"], ["AF", "+93", "Afghanistan"],
  ["AE", "+971", "UAE"], ["SA", "+966", "Saudi Arabia"], ["QA", "+974", "Qatar"], ["OM", "+968", "Oman"],
  ["ZA", "+27", "South Africa"], ["NZ", "+64", "New Zealand"], ["ZW", "+263", "Zimbabwe"], ["IE", "+353", "Ireland"],
  ["US", "+1", "United States"], ["CA", "+1", "Canada"], ["SG", "+65", "Singapore"], ["MY", "+60", "Malaysia"],
  ["KE", "+254", "Kenya"], ["NL", "+31", "Netherlands"],
];
